import type {
  EmbeddedIframeSandbox,
  EmbeddedToolbarAction,
} from '@/types/embeddedApplication';

export const defaultEmbeddedToolbarActions: EmbeddedToolbarAction[] = [
  { id: 'popOut', visible: true },
];

export const defaultEmbeddedIframeSandbox: EmbeddedIframeSandbox = {
  allowSameOrigin: true,
  allowScripts: true,
  allowForms: true,
  allowPopups: true,
  allowFullscreen: true,
  // Required by some legacy auth flows and popup providers inside embedded apps.
  additionalTokens: [
    'allow-top-navigation-by-user-activation',
    'allow-popups-to-escape-sandbox',
  ],
};

export const embeddedLoadTimeoutMs = 30000;

export const embeddedSidebarWidth = 240;

export const embeddedNavigationSearchMinLength = 0;
